export const formatValueAsCurrency = amount => {
  /*
   * Formatter that can be used for currency in the front end.
   * */
  let USDollarFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
    trailingZeroDisplay: 'stripIfInteger'
  })

  return USDollarFormatter.format(amount)
}
